import { Palette, ChevronDown } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuLabel,
  DropdownMenuRadioGroup, DropdownMenuRadioItem,
} from '@/components/ui/dropdown-menu';

const options = [
  { value: 'contraste', label: 'Gotham Contrasté', short: 'Contrasté' },
  { value: 'emeraude', label: 'Gotham Émeraude', short: 'Émeraude' },
];

export const AdminPaletteSelector = ({ palette, onChange }) => {
  const selected = options.find((option) => option.value === palette) || options[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className="admin-palette-trigger" data-testid="admin-palette-selector"
          aria-label={`Choisir le thème : ${selected.label}`} title={`Thème : ${selected.label}`}>
          <Palette className="h-4 w-4" aria-hidden="true" />
          <span data-testid="admin-palette-current">{selected.short}</span>
          <ChevronDown className="h-3 w-3 admin-palette-chevron" aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={8} className="admin-palette-menu" data-testid="admin-palette-menu">
        <DropdownMenuLabel className="px-3 pt-2 pb-2 text-xs" data-testid="admin-palette-menu-title">Thème de l’interface</DropdownMenuLabel>
        <DropdownMenuRadioGroup value={palette} onValueChange={onChange} aria-label="Thème de l’interface" data-testid="admin-palette-options">
          {options.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value} className="admin-palette-option" data-testid={`admin-palette-option-${option.value}`}>
              <span className={`admin-palette-swatch admin-palette-swatch-${option.value}`} aria-hidden="true"><i /><i /><i /></span>
              <span>{option.label}</span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};